<template>
  <a
    :href="href"
    :target="target"
    @click="clickHandler($event)"
    :class="{ 'has-button': hasButton }"
    class="cs-link">
      <slot>{{ title }}</slot>
  </a>
</template>

<script>

export default {
  name: 'cs-link',
  props: {

    // string
    // router object { path, hash, params, query, [title] }
    // kirby link-object
    // kirby page-head-object
    data: null,

    // use $router.replace() instead of $router.push()
    replace: {
      type: Boolean,
      default: false
    },

    // scroll options for anchor links
    scrollOptions: {}
  },
  computed: {
    href () {
      if (fn.isObject(this.data)) {

        // kirby object
        if (fn.has(this.data, 'type')) {
          switch (this.data.type) {
            case 'node':
              if (fn.has(this.data, 'redirect')) {
                return this.data.redirect
              } else if (fn.has(this.data, 'value')) {
                return this.data.value
              } else {
                return this.data.uri
              }
            case 'item':
              if (fn.has(this.data, 'value')) {
                return this.data.value
              } else {
                return this.data.uri
              }
            case 'extern':
              return this.data.value
            case 'email':
            case 'file':
            case 'tel':
              return this.data.value
          }
        }

        // router object https://router.vuejs.org/guide/essentials/navigation.html
        else if (this.isRouterLink) {
          var route = this.$router.resolve(this.data)
          return route.href || '/'
        }
      }

      // extern url
      else if (fn.isUrl(this.data)) {
        return this.data
      }

      // email
      else if (fn.isEmail(this.data)) {
        return 'mailto:' + this.data
      }
      return null
    },
    target () {
      if ((fn.isObject(this.data) && this.data.type === 'extern') || fn.isUrl(this.data)) {
        return '_blank'
      }
      return null
    },
    title () {
      if (fn.isObject(this.data)) {
        return this.data.title
      } else if (fn.isEmail(this.data)) {
        return this.data
      }
      return this.href
    },
    anchor () {
      if (fn.isObject(this.data) && this.data.type === 'anchor') {
        return this.data.value
      }
      return null
    },
    isKirbyLink () {
      return fn.isString(this.data) ||
        (fn.isObject(this.data) && (this.data.type === 'node' || this.data.type === 'item'))
    },
    isRouterLink () {
      return fn.has(this.data, 'path') ||
        fn.has(this.data, 'hash') ||
        fn.has(this.data, 'params') ||
        fn.has(this.data, 'query')
    },
    hasButton () {
      if(this.$slots.default && this.$slots.default[0].componentOptions) {
        return this.$slots.default[0].componentOptions.tag === 'cs-button'
      }
      return false
    }
  },
  methods: {
    clickHandler (Event) {
      Event.stopPropagation()
      if (this.isRouterLink) {
        Event.preventDefault()
        this.goToRoute(this.data)
      } else if (this.isKirbyLink) {
        Event.preventDefault()
        this.goToRoute(this.href)
      }
      this.$emit('click', Event, this.data)
    },
    goToRoute (target) {
      if (this.replace) {
        this.$router.replace(target).catch(err => {})
      } else {
        this.$router.push(target).catch(err => {})
      }
    }
  }
}
</script>

<style lang="sass">
.cs-link
  cursor: pointer
  &.has-button
    text-decoration: none !important
    cursor: default
</style>  